module.exports = __webpack_public_path__ + "img/u92.c990aee2.jpg";